const PONDER = {
  1: 'Broke',
  2: 'Challenging',
  3: 'Neutral',
  4: 'Solid',
  5: 'Relaxed',
};
export default PONDER;
